/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AcceptFriendInviteBody,
  AcceptFriendInviteResponse,
  ApiError,
  BlockUserBody,
  BlockUserResponse,
  CreateFriendInviteBody,
  CreateFriendInviteResponse,
  GetMyFriendsResponse,
  GetOnlineFriendsResponse,
  GetPendingFriendRequestsResponse,
  RemoveFriendResponse,
  RespondFriendRequestBody,
  RespondFriendRequestResponse,
  SendFriendRequestBody,
  SendFriendRequestResponse,
  UnblockUserResponse,
  UpdateFriendLabelBody,
  UpdateFriendLabelResponse,
} from '../models/index';
import {
    AcceptFriendInviteBodyFromJSON,
    AcceptFriendInviteBodyToJSON,
    AcceptFriendInviteResponseFromJSON,
    AcceptFriendInviteResponseToJSON,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    BlockUserBodyFromJSON,
    BlockUserBodyToJSON,
    BlockUserResponseFromJSON,
    BlockUserResponseToJSON,
    CreateFriendInviteBodyFromJSON,
    CreateFriendInviteBodyToJSON,
    CreateFriendInviteResponseFromJSON,
    CreateFriendInviteResponseToJSON,
    GetMyFriendsResponseFromJSON,
    GetMyFriendsResponseToJSON,
    GetOnlineFriendsResponseFromJSON,
    GetOnlineFriendsResponseToJSON,
    GetPendingFriendRequestsResponseFromJSON,
    GetPendingFriendRequestsResponseToJSON,
    RemoveFriendResponseFromJSON,
    RemoveFriendResponseToJSON,
    RespondFriendRequestBodyFromJSON,
    RespondFriendRequestBodyToJSON,
    RespondFriendRequestResponseFromJSON,
    RespondFriendRequestResponseToJSON,
    SendFriendRequestBodyFromJSON,
    SendFriendRequestBodyToJSON,
    SendFriendRequestResponseFromJSON,
    SendFriendRequestResponseToJSON,
    UnblockUserResponseFromJSON,
    UnblockUserResponseToJSON,
    UpdateFriendLabelBodyFromJSON,
    UpdateFriendLabelBodyToJSON,
    UpdateFriendLabelResponseFromJSON,
    UpdateFriendLabelResponseToJSON,
} from '../models/index';

export interface CreateFriendsBlockRequest {
    blockUserBody: BlockUserBody;
}

export interface CreateFriendsInviteRequest {
    createFriendInviteBody?: CreateFriendInviteBody;
}

export interface CreateFriendsInviteAcceptRequest {
    acceptFriendInviteBody: AcceptFriendInviteBody;
}

export interface CreateFriendsRequestRequest {
    sendFriendRequestBody: SendFriendRequestBody;
}

export interface CreateFriendsRespondRequest {
    respondFriendRequestBody: RespondFriendRequestBody;
}

export interface DeleteFriendsBlockUserIdRequest {
    userId: string;
}

export interface DeleteFriendsFriendIdRequest {
    friendId: string;
}

export interface UpdateFriendsFriendIdLabelRequest {
    friendId: string;
    updateFriendLabelBody: UpdateFriendLabelBody;
}

/**
 * FriendsApi - interface
 * 
 * @export
 * @interface FriendsApiInterface
 */
export interface FriendsApiInterface {
    /**
     * Block a user. If you were friends, the friendship is removed. No notification is sent to the blocked user.
     * @summary Block a user
     * @param {BlockUserBody} blockUserBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FriendsApiInterface
     */
    createFriendsBlockRaw(requestParameters: CreateFriendsBlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BlockUserResponse>>;

    /**
     * Block a user. If you were friends, the friendship is removed. No notification is sent to the blocked user.
     * Block a user
     */
    createFriendsBlock(requestParameters: CreateFriendsBlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BlockUserResponse>;

    /**
     * Creates a friend invite with a unique shareable code (30-day TTL). If an email is provided, sends an invitation email and tags the invite to that address. The invite code can be embedded in a sign-up URL (/join?friendInvite=CODE) so that new users are auto-friended on account creation. Existing users can also accept via POST /friends/invite/accept. 
     * @summary Generate a friend invite link
     * @param {CreateFriendInviteBody} [createFriendInviteBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FriendsApiInterface
     */
    createFriendsInviteRaw(requestParameters: CreateFriendsInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFriendInviteResponse>>;

    /**
     * Creates a friend invite with a unique shareable code (30-day TTL). If an email is provided, sends an invitation email and tags the invite to that address. The invite code can be embedded in a sign-up URL (/join?friendInvite=CODE) so that new users are auto-friended on account creation. Existing users can also accept via POST /friends/invite/accept. 
     * Generate a friend invite link
     */
    createFriendsInvite(requestParameters: CreateFriendsInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFriendInviteResponse>;

    /**
     * Called when an already-authenticated user clicks a friend invite link. Validates the invite code, then creates a bilateral ACCEPTED friendship immediately — skipping the normal PENDING → ACCEPTED flow. For new users signing up via a friend invite link, the friendship is created automatically inside getOrCreateUserWithEmail; this endpoint is only for users who already have an account. 
     * @summary Accept a friend invite (existing user flow)
     * @param {AcceptFriendInviteBody} acceptFriendInviteBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FriendsApiInterface
     */
    createFriendsInviteAcceptRaw(requestParameters: CreateFriendsInviteAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AcceptFriendInviteResponse>>;

    /**
     * Called when an already-authenticated user clicks a friend invite link. Validates the invite code, then creates a bilateral ACCEPTED friendship immediately — skipping the normal PENDING → ACCEPTED flow. For new users signing up via a friend invite link, the friendship is created automatically inside getOrCreateUserWithEmail; this endpoint is only for users who already have an account. 
     * Accept a friend invite (existing user flow)
     */
    createFriendsInviteAccept(requestParameters: CreateFriendsInviteAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AcceptFriendInviteResponse>;

    /**
     * Send a friend request to the specified user. Cannot send to yourself, blocked users, or users who have blocked you.
     * @summary Send a friend request to another user
     * @param {SendFriendRequestBody} sendFriendRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FriendsApiInterface
     */
    createFriendsRequestRaw(requestParameters: CreateFriendsRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendFriendRequestResponse>>;

    /**
     * Send a friend request to the specified user. Cannot send to yourself, blocked users, or users who have blocked you.
     * Send a friend request to another user
     */
    createFriendsRequest(requestParameters: CreateFriendsRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendFriendRequestResponse>;

    /**
     * Respond to an incoming friend request by accepting or declining it.
     * @summary Accept or decline a friend request
     * @param {RespondFriendRequestBody} respondFriendRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FriendsApiInterface
     */
    createFriendsRespondRaw(requestParameters: CreateFriendsRespondRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RespondFriendRequestResponse>>;

    /**
     * Respond to an incoming friend request by accepting or declining it.
     * Accept or decline a friend request
     */
    createFriendsRespond(requestParameters: CreateFriendsRespondRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RespondFriendRequestResponse>;

    /**
     * Remove a user from your blocked list. This does not automatically restore friendship - a new friend request must be sent.
     * @summary Unblock a user
     * @param {string} userId The user ID to unblock
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FriendsApiInterface
     */
    deleteFriendsBlockUserIdRaw(requestParameters: DeleteFriendsBlockUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnblockUserResponse>>;

    /**
     * Remove a user from your blocked list. This does not automatically restore friendship - a new friend request must be sent.
     * Unblock a user
     */
    deleteFriendsBlockUserId(requestParameters: DeleteFriendsBlockUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnblockUserResponse>;

    /**
     * Remove an existing friend from your friends list. This is silent - no notification is sent.
     * @summary Remove a friend
     * @param {string} friendId The user ID of the friend to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FriendsApiInterface
     */
    deleteFriendsFriendIdRaw(requestParameters: DeleteFriendsFriendIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RemoveFriendResponse>>;

    /**
     * Remove an existing friend from your friends list. This is silent - no notification is sent.
     * Remove a friend
     */
    deleteFriendsFriendId(requestParameters: DeleteFriendsFriendIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RemoveFriendResponse>;

    /**
     * Retrieve the authenticated user\'s friends list including accepted friends, pending counts, and blocked counts.
     * @summary Get current user\'s friends list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FriendsApiInterface
     */
    getMeFriendsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMyFriendsResponse>>;

    /**
     * Retrieve the authenticated user\'s friends list including accepted friends, pending counts, and blocked counts.
     * Get current user\'s friends list
     */
    getMeFriends(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMyFriendsResponse>;

    /**
     * Retrieve only friends who are currently online, with their game status if playing.
     * @summary Get current user\'s online friends
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FriendsApiInterface
     */
    getMeFriendsOnlineRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOnlineFriendsResponse>>;

    /**
     * Retrieve only friends who are currently online, with their game status if playing.
     * Get current user\'s online friends
     */
    getMeFriendsOnline(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOnlineFriendsResponse>;

    /**
     * Retrieve both incoming and outgoing pending friend requests.
     * @summary Get pending friend requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FriendsApiInterface
     */
    getMeFriendsPendingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPendingFriendRequestsResponse>>;

    /**
     * Retrieve both incoming and outgoing pending friend requests.
     * Get pending friend requests
     */
    getMeFriendsPending(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPendingFriendRequestsResponse>;

    /**
     * Set or clear a custom label for a friend (e.g., \"Work buddy\", \"College friend\"). Labels are only visible to you.
     * @summary Set a custom label for a friend
     * @param {string} friendId The user ID of the friend
     * @param {UpdateFriendLabelBody} updateFriendLabelBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FriendsApiInterface
     */
    updateFriendsFriendIdLabelRaw(requestParameters: UpdateFriendsFriendIdLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateFriendLabelResponse>>;

    /**
     * Set or clear a custom label for a friend (e.g., \"Work buddy\", \"College friend\"). Labels are only visible to you.
     * Set a custom label for a friend
     */
    updateFriendsFriendIdLabel(requestParameters: UpdateFriendsFriendIdLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateFriendLabelResponse>;

}

/**
 * 
 */
export class FriendsApi extends runtime.BaseAPI implements FriendsApiInterface {

    /**
     * Block a user. If you were friends, the friendship is removed. No notification is sent to the blocked user.
     * Block a user
     */
    async createFriendsBlockRaw(requestParameters: CreateFriendsBlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BlockUserResponse>> {
        if (requestParameters['blockUserBody'] == null) {
            throw new runtime.RequiredError(
                'blockUserBody',
                'Required parameter "blockUserBody" was null or undefined when calling createFriendsBlock().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/friends/block`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BlockUserBodyToJSON(requestParameters['blockUserBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BlockUserResponseFromJSON(jsonValue));
    }

    /**
     * Block a user. If you were friends, the friendship is removed. No notification is sent to the blocked user.
     * Block a user
     */
    async createFriendsBlock(requestParameters: CreateFriendsBlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BlockUserResponse> {
        const response = await this.createFriendsBlockRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a friend invite with a unique shareable code (30-day TTL). If an email is provided, sends an invitation email and tags the invite to that address. The invite code can be embedded in a sign-up URL (/join?friendInvite=CODE) so that new users are auto-friended on account creation. Existing users can also accept via POST /friends/invite/accept. 
     * Generate a friend invite link
     */
    async createFriendsInviteRaw(requestParameters: CreateFriendsInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFriendInviteResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/friends/invite`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFriendInviteBodyToJSON(requestParameters['createFriendInviteBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFriendInviteResponseFromJSON(jsonValue));
    }

    /**
     * Creates a friend invite with a unique shareable code (30-day TTL). If an email is provided, sends an invitation email and tags the invite to that address. The invite code can be embedded in a sign-up URL (/join?friendInvite=CODE) so that new users are auto-friended on account creation. Existing users can also accept via POST /friends/invite/accept. 
     * Generate a friend invite link
     */
    async createFriendsInvite(requestParameters: CreateFriendsInviteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFriendInviteResponse> {
        const response = await this.createFriendsInviteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Called when an already-authenticated user clicks a friend invite link. Validates the invite code, then creates a bilateral ACCEPTED friendship immediately — skipping the normal PENDING → ACCEPTED flow. For new users signing up via a friend invite link, the friendship is created automatically inside getOrCreateUserWithEmail; this endpoint is only for users who already have an account. 
     * Accept a friend invite (existing user flow)
     */
    async createFriendsInviteAcceptRaw(requestParameters: CreateFriendsInviteAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AcceptFriendInviteResponse>> {
        if (requestParameters['acceptFriendInviteBody'] == null) {
            throw new runtime.RequiredError(
                'acceptFriendInviteBody',
                'Required parameter "acceptFriendInviteBody" was null or undefined when calling createFriendsInviteAccept().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/friends/invite/accept`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AcceptFriendInviteBodyToJSON(requestParameters['acceptFriendInviteBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AcceptFriendInviteResponseFromJSON(jsonValue));
    }

    /**
     * Called when an already-authenticated user clicks a friend invite link. Validates the invite code, then creates a bilateral ACCEPTED friendship immediately — skipping the normal PENDING → ACCEPTED flow. For new users signing up via a friend invite link, the friendship is created automatically inside getOrCreateUserWithEmail; this endpoint is only for users who already have an account. 
     * Accept a friend invite (existing user flow)
     */
    async createFriendsInviteAccept(requestParameters: CreateFriendsInviteAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AcceptFriendInviteResponse> {
        const response = await this.createFriendsInviteAcceptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send a friend request to the specified user. Cannot send to yourself, blocked users, or users who have blocked you.
     * Send a friend request to another user
     */
    async createFriendsRequestRaw(requestParameters: CreateFriendsRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendFriendRequestResponse>> {
        if (requestParameters['sendFriendRequestBody'] == null) {
            throw new runtime.RequiredError(
                'sendFriendRequestBody',
                'Required parameter "sendFriendRequestBody" was null or undefined when calling createFriendsRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/friends/request`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendFriendRequestBodyToJSON(requestParameters['sendFriendRequestBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SendFriendRequestResponseFromJSON(jsonValue));
    }

    /**
     * Send a friend request to the specified user. Cannot send to yourself, blocked users, or users who have blocked you.
     * Send a friend request to another user
     */
    async createFriendsRequest(requestParameters: CreateFriendsRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendFriendRequestResponse> {
        const response = await this.createFriendsRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Respond to an incoming friend request by accepting or declining it.
     * Accept or decline a friend request
     */
    async createFriendsRespondRaw(requestParameters: CreateFriendsRespondRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RespondFriendRequestResponse>> {
        if (requestParameters['respondFriendRequestBody'] == null) {
            throw new runtime.RequiredError(
                'respondFriendRequestBody',
                'Required parameter "respondFriendRequestBody" was null or undefined when calling createFriendsRespond().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/friends/respond`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RespondFriendRequestBodyToJSON(requestParameters['respondFriendRequestBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RespondFriendRequestResponseFromJSON(jsonValue));
    }

    /**
     * Respond to an incoming friend request by accepting or declining it.
     * Accept or decline a friend request
     */
    async createFriendsRespond(requestParameters: CreateFriendsRespondRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RespondFriendRequestResponse> {
        const response = await this.createFriendsRespondRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a user from your blocked list. This does not automatically restore friendship - a new friend request must be sent.
     * Unblock a user
     */
    async deleteFriendsBlockUserIdRaw(requestParameters: DeleteFriendsBlockUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnblockUserResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling deleteFriendsBlockUserId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/friends/block/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnblockUserResponseFromJSON(jsonValue));
    }

    /**
     * Remove a user from your blocked list. This does not automatically restore friendship - a new friend request must be sent.
     * Unblock a user
     */
    async deleteFriendsBlockUserId(requestParameters: DeleteFriendsBlockUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnblockUserResponse> {
        const response = await this.deleteFriendsBlockUserIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove an existing friend from your friends list. This is silent - no notification is sent.
     * Remove a friend
     */
    async deleteFriendsFriendIdRaw(requestParameters: DeleteFriendsFriendIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RemoveFriendResponse>> {
        if (requestParameters['friendId'] == null) {
            throw new runtime.RequiredError(
                'friendId',
                'Required parameter "friendId" was null or undefined when calling deleteFriendsFriendId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/friends/{friendId}`;
        urlPath = urlPath.replace(`{${"friendId"}}`, encodeURIComponent(String(requestParameters['friendId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RemoveFriendResponseFromJSON(jsonValue));
    }

    /**
     * Remove an existing friend from your friends list. This is silent - no notification is sent.
     * Remove a friend
     */
    async deleteFriendsFriendId(requestParameters: DeleteFriendsFriendIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RemoveFriendResponse> {
        const response = await this.deleteFriendsFriendIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the authenticated user\'s friends list including accepted friends, pending counts, and blocked counts.
     * Get current user\'s friends list
     */
    async getMeFriendsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMyFriendsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/me/friends`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMyFriendsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve the authenticated user\'s friends list including accepted friends, pending counts, and blocked counts.
     * Get current user\'s friends list
     */
    async getMeFriends(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMyFriendsResponse> {
        const response = await this.getMeFriendsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve only friends who are currently online, with their game status if playing.
     * Get current user\'s online friends
     */
    async getMeFriendsOnlineRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOnlineFriendsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/me/friends/online`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOnlineFriendsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve only friends who are currently online, with their game status if playing.
     * Get current user\'s online friends
     */
    async getMeFriendsOnline(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOnlineFriendsResponse> {
        const response = await this.getMeFriendsOnlineRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve both incoming and outgoing pending friend requests.
     * Get pending friend requests
     */
    async getMeFriendsPendingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPendingFriendRequestsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/me/friends/pending`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPendingFriendRequestsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve both incoming and outgoing pending friend requests.
     * Get pending friend requests
     */
    async getMeFriendsPending(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPendingFriendRequestsResponse> {
        const response = await this.getMeFriendsPendingRaw(initOverrides);
        return await response.value();
    }

    /**
     * Set or clear a custom label for a friend (e.g., \"Work buddy\", \"College friend\"). Labels are only visible to you.
     * Set a custom label for a friend
     */
    async updateFriendsFriendIdLabelRaw(requestParameters: UpdateFriendsFriendIdLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateFriendLabelResponse>> {
        if (requestParameters['friendId'] == null) {
            throw new runtime.RequiredError(
                'friendId',
                'Required parameter "friendId" was null or undefined when calling updateFriendsFriendIdLabel().'
            );
        }

        if (requestParameters['updateFriendLabelBody'] == null) {
            throw new runtime.RequiredError(
                'updateFriendLabelBody',
                'Required parameter "updateFriendLabelBody" was null or undefined when calling updateFriendsFriendIdLabel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/friends/{friendId}/label`;
        urlPath = urlPath.replace(`{${"friendId"}}`, encodeURIComponent(String(requestParameters['friendId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFriendLabelBodyToJSON(requestParameters['updateFriendLabelBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateFriendLabelResponseFromJSON(jsonValue));
    }

    /**
     * Set or clear a custom label for a friend (e.g., \"Work buddy\", \"College friend\"). Labels are only visible to you.
     * Set a custom label for a friend
     */
    async updateFriendsFriendIdLabel(requestParameters: UpdateFriendsFriendIdLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateFriendLabelResponse> {
        const response = await this.updateFriendsFriendIdLabelRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
